/* 🤖 this file was generated by svg-to-ts*/
export const iconLoading: {
  name: 'loading';
  data: string;
} = {
  name: 'loading',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M15.525 5.592a.998.998 0 00-1.376.325l-.144.233C13.185 3.189 10.418 1 7.13 1 3.198 1 0 4.125 0 7.966s3.198 6.966 7.13 6.966a1 1 0 100-2C4.301 12.932 2 10.704 2 7.966S4.301 3 7.13 3c2.414 0 4.431 1.628 4.974 3.806l-.484-.282a.997.997 0 00-1.367.359.998.998 0 00.359 1.367l1.283.749c.371.217.78.321 1.185.321.791 0 1.564-.395 2.001-1.104l.77-1.248a1 1 0 00-.326-1.376"/></svg>`,
};
